import axios from "@/api/axiosInstance";
import { CreateStageRequest, CreateStageResponse } from "./types";

export const createStage = async (
  requestData: CreateStageRequest,
): Promise<CreateStageResponse> => {
  const response = await axios.post<CreateStageResponse>(
    "/api/private/admin/stages",
    requestData,
  );
  return response.data;
};
